export const BLACKLISTED_DOMAINS: Map<string, string[]> = new Map([['Rocket Math', ['^(.+\\.)?lr-in\\.com$']]]);
